import AddRole from "../../Components/Modals/AddRole";
import Table from "../../Components/Table";
import { deleteRoleById, getRoles } from "../../Services/MasterService";

const Role = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    }
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddRole data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getRoles}
      columns={columns}
      title={"Roles Master"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteRoleById}
    />
  );
}

export default Role;